export default "__VITE_ASSET__BzfYnhtD__"